exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.text-danger-muted {\n\tcolor: #e8928e !important;\n}\n.text-success-muted {\n\tcolor: #71c78b !important;\n}\n", ""]);

// exports
